<template>
  <div class="page-header header-filter" style="background-image: url('img/bg32.jpg')">
    <!-- <div class="page-header-image"
             style="background-image: url('img/login.jpg')">
    </div>-->
   <form @submit="handleSubmit" class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="mr-auto">
              <!-- <img v-lazy="'img/now-logo.png'" alt=""> -->
              <h1 class="title">{{ constants.appTitle }}</h1>
            </div>

            <fg-input class="no-border input-lg">
              <el-select class="select-default" v-model="form.tipoDocumento">
                <el-option
                  v-for="item in form.tipoDocumentoList"
                  class="option-item"
                  :value="item.TipoDocumentoId"
                  :label="item.TipoDocumentoNombre"
                  :key="item.TipoDocumentoId"
                ></el-option>
              </el-select>
            </fg-input>

            <fg-input
              ref="numeroDocumento"
              v-model="form.numeroDocumento"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons users_circle-08"
              placeholder="Numero de documento"
            ></fg-input>

            <fg-input
              type="password"
              v-model="form.password"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              placeholder="Contraseña"
            ></fg-input>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <button
                type="submit"
                  class="btn btn-primary btn-round btn-lg btn-block"
                >Ingresar</button>
              </div>
              <div class="card-footer text-center">
                <h6>                  
                  <a href="#/register" class="link linkRegistrar">Registrarse</a>
                </h6>
              </div>
              <div class="card-footer text-center">
                <!-- pull-right                 -->
                <h6>
                  <a href="#/reset" class="link footer-link">¿Olvidaste la contraseña?</a>
                </h6>
              </div>
               
            </template>
          </card>
        </div>
      </div>
    </form>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from '@/components';
import { Select, Option } from 'element-ui';
import * as miscService from '../../services/MiscService';
import * as authService from '../../services/AuthService';

export default {
  name: 'login-page',
  bodyClass: 'login-page',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        phone: '',
        numeroDocumento: '',
        tipoDocumento: '',
        tipoDocumentoList: [],
        password: ''
      }
    };
  },
  async mounted() {
    this.form.tipoDocumentoList = await miscService.getAllTipoDocumentos();
    this.form.tipoDocumento = 96; //DNI por defecto
    this.focusInput();
  },
  methods: {
    handleSubmit: function(event) {
      var self = this;

      event.preventDefault();
      
      if (self.form.tipoDocumento==='' || self.form.tipoDocumento==null){
        self.$noty.error('El tipo de documento es obligatorio');
        return;
      }

      if (self.form.numeroDocumento==='' || self.form.numeroDocumento==null){
        self.$noty.error('El numero de documento es obligatorio');
        return;
      }

      if (self.form.password==='' || self.form.password==null){
        self.$noty.error('La contraseña es obligatoria');
        return;
      }

      authService.login(
        this.form.tipoDocumento,
        this.form.numeroDocumento,
        this.form.password,
        success => {},
        error => this.$noty.error(error)
      );
    },
     focusInput() {
       //debugger;
       //console.log('focus focus');
     //  this.$nextTick(() => this.$refs.numeroDocumento.$el.children[1].focus());
     //  this.$refs.numeroDocumento.$el.focus();
    }
  }
};
</script>
<style scoped>
.card
  a:not(.btn):not(.nav-link):not([data-toggle='collapse']):not(.footer-link) {
  font-size: 25px;
  border-bottom: 2px solid transparent;
  color: #ffffff;
}
/* a .linkRegistrar {
  text-decoration: none;
} */

.login-page .link {
  color: #ffffff !important;
  text-decoration: none;
}
</style>
